webpackJsonp([1,2],{

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            dragEnabled: true,
            hasDragged: false,
            isDragging: false,
            startX: 0,
            scrollLeftStart: 0,
            velocity: 0,
            lastX: 0,
            lastTime: 0,
            timerSeconds: window.timerSeconds,
            timerId: null,
            valid: window.valid,
            isSearchFocus: false,
            hideSportTitle: window.hideSportTitle
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['arr_lang', 'titleSport', 'lang_id', 'liveMatchList', 'sortedliveMatchList', 'selectedMatch', 'selectedSport', 'firstLoad', 'minWidth', 'isMobile', 'error']), {
        searchKeyword: {
            set: function set(val) {
                this.$store.commit('SET_KEYWORD', val);
                this.$store.dispatch('sortLiveMatch');
            },
            get: function get() {
                return this.$store.getters.keyword;
            }
        }
    }),
    watch: {
        selectedMatch: function selectedMatch(newval) {
            this.$nextTick(function () {
                var container = document.querySelector('.scroll');
                var el = document.getElementById('lsm_' + newval.eveid);
                var banner = document.querySelector('.banner-row');
                var nav = document.querySelector('.MLSrow1');

                if (!container || !el) return;

                var elRect = el.getBoundingClientRect();
                var bannerRect = banner.getBoundingClientRect();
                var navRect = nav.getBoundingClientRect();
                var target = bannerRect.height + navRect.height;

                container.scrollTop = container.scrollTop + elRect.top - target;
            });
        }
    },
    methods: {
        clickToScroll: function clickToScroll(side) {
            var scrollAmount = 150;
            var container = this.$refs.tabWrapList;

            container.style.scrollBehavior = 'smooth';
            container.scrollBy({ left: side === 'left' ? -scrollAmount : scrollAmount });
            setTimeout(function () {
                return container.style.scrollBehavior = 'auto';
            }, 300);
            this.updateScrollButtons();
        },
        updateScrollButtons: function updateScrollButtons() {
            var container = this.$refs.tabWrapList;
            if (!container) return;
            var leftDisabled = container.scrollLeft <= 0;
            var rightDisabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;

            var scrollLeftBtn = document.getElementById('scrollLeft');
            var scrollRightBtn = document.getElementById('scrollRight');
            if (!scrollLeftBtn || !scrollLeftBtn) return;
            scrollLeftBtn.disabled = leftDisabled;
            scrollRightBtn.disabled = rightDisabled;
        },
        startDrag: function startDrag(e) {
            if (!this.dragEnabled) return;
            this.isDragging = true;
            this.hasDragged = false;
            this.startX = e.pageX || e.touches[0].pageX;
            this.scrollLeftStart = this.$refs.tabWrapList.scrollLeft;
            this.lastX = this.startX;
            this.lastTime = performance.now();
            this.velocity = 0;
            this.$refs.tabWrapList.classList.add('dragging');
        },
        duringDrag: function duringDrag(e) {
            if (!this.dragEnabled || !this.isDragging) return;
            e.preventDefault();
            var x = e.pageX || e.touches[0].pageX;
            var delta = this.startX - x;

            if (Math.abs(delta) > 5) {
                this.hasDragged = true;
                e.preventDefault();
            }

            this.$refs.tabWrapList.scrollLeft = this.scrollLeftStart + delta;

            var now = performance.now();
            var dt = now - this.lastTime;
            if (dt > 0) {
                this.velocity = (this.lastX - x) / dt;
                this.lastX = x;
                this.lastTime = now;
            }
        },
        stopDrag: function stopDrag() {
            var _this = this;

            if (!this.dragEnabled) return;
            this.isDragging = false;
            this.$refs.tabWrapList.classList.remove('dragging');
            setTimeout(function () {
                return _this.updateScrollButtons();
            }, 50);
            setTimeout(function () {
                _this.hasDragged = false;
            }, 0);
        },
        clearSearchBox: function clearSearchBox() {
            this.searchKeyword = "";
        },
        onSportClick: function onSportClick(sid, e) {
            if (this.hasDragged) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            this.getLSMatchList(sid);
        },
        getLSMatchList: function getLSMatchList() {
            var sid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (window.valid) {
                document.querySelector('.rightMLS-col.scrollable').scrollTop = 0;
                this.clearSearchBox();

                this.$store.dispatch('getLiveMatchList', {
                    sport: sid,
                    lang: this.lang_id,
                    loading: 0,
                    token: token.arr_6
                });
            }
        },
        startTimer: function startTimer() {
            var _this2 = this;

            if (this.timerId == null) {
                this.timerId = setInterval(function () {
                    if (_this2.timerSeconds - 1 < 0) {
                        _this2.reloadTable(token.arr_1);
                    } else {
                        _this2.timerSeconds -= 1;
                    }
                }, 1000);
            }
        },
        refreshTimer: function refreshTimer() {
            this.clearTimer();
            this.timerSeconds = window.timerSeconds;
            this.startTimer();
        },
        clearTimer: function clearTimer() {
            clearInterval(this.timerId);
            this.timerId = null;
        },
        reloadTable: function reloadTable() {
            var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (window.valid) {
                this.$store.dispatch('getLiveMatchList', {
                    sport: this.selectedSport,
                    lang: this.lang_id,
                    loading: 0,
                    token: token_val
                });
                this.refreshTimer();
            } else {
                this.clearTimer();
            }
        },
        getLiveStreamURL: function getLiveStreamURL(eve) {
            if (window.valid) {
                this.$store.commit('SELECTED_SPORT', eve.sptid);
                this.$store.dispatch('updateSelectedMatch', eve);
            }
        },
        getDateTimeFormat: function getDateTimeFormat(dt) {
            return new __WEBPACK_IMPORTED_MODULE_6_moment___default.a(dt).format("YYYY-MM-DD HH:mm");
        },
        onSearchFocus: function onSearchFocus() {
            this.isSearchFocus = true;
        },
        closeSearch: function closeSearch() {
            this.isSearchFocus = false;
            this.clearSearchBox();
        },
        handleResize: function handleResize() {
            var _this3 = this;

            this.$store.commit('IS_MOBILE', window.innerWidth < this.minWidth);
            this.$nextTick(function () {
                _this3.unbindScrollEvents();
                _this3.dragEnabled = !_this3.isMobile;
                if (!_this3.isMobile) {
                    _this3.bindScrollEvents();
                    _this3.updateScrollButtons();
                }
            });
            if (this.isMobile) {
                var banner = document.querySelector('.banner-row');
                var mobileWrap = document.querySelector('.mobile-wrap');
                if (!banner || !mobileWrap) return;
                var nav = mobileWrap.querySelector('.MLSrow1');
                var el = mobileWrap.querySelector('.MLSrow2');
                if (!nav || !el) return;
                var bannerRect = banner.getBoundingClientRect();
                var navRect = nav.getBoundingClientRect();
                var target = bannerRect.height + navRect.height - 10;
                el.style.marginTop = target + 'px';
            } else {
                var _el = document.querySelector('.MLSrow2');
                if (!_el) return;
                _el.style.marginTop = '';
            }
            if (this.pointerMQ) {
                this.handlePointerChange();
            }
        },
        handlePointerChange: function handlePointerChange() {
            var _this4 = this;

            var isTouch = this.pointerMQ.matches;
            this.$nextTick(function () {
                _this4.unbindScrollEvents();
                _this4.dragEnabled = !isTouch;

                var el = _this4.$refs.tabWrapList;
                if (!el) return;

                el.classList.toggle('mob-dev', isTouch);
                el.classList.toggle('web-dev', !isTouch);

                if (!isTouch) {
                    _this4.bindScrollEvents();
                }
            });
        },
        bindScrollEvents: function bindScrollEvents() {
            if (!this.dragEnabled) return;
            var container = this.$refs.tabWrapList;
            if (!container) return;

            container.addEventListener('scroll', this.updateScrollButtons);
            window.addEventListener('resize', this.updateScrollButtons);
            container.addEventListener('mousedown', this.startDrag);
            container.addEventListener('mousemove', this.duringDrag);
            container.addEventListener('mouseup', this.stopDrag);
            container.addEventListener('mouseleave', this.stopDrag);

            container.addEventListener('touchstart', this.startDrag, { passive: false });
            container.addEventListener('touchmove', this.duringDrag, { passive: false });
            container.addEventListener('touchend', this.stopDrag);
            container.addEventListener('touchcancel', this.stopDrag);
        },
        unbindScrollEvents: function unbindScrollEvents() {
            var container = this.$refs.tabWrapList;
            if (!container) return;

            container.removeEventListener('scroll', this.updateScrollButtons);
            window.removeEventListener('resize', this.updateScrollButtons);
            container.removeEventListener('mousedown', this.startDrag);
            container.removeEventListener('mousemove', this.duringDrag);
            container.removeEventListener('mouseup', this.stopDrag);
            container.removeEventListener('mouseleave', this.stopDrag);

            container.removeEventListener('touchstart', this.startDrag);
            container.removeEventListener('touchmove', this.duringDrag);
            container.removeEventListener('touchend', this.stopDrag);
            container.removeEventListener('touchcancel', this.stopDrag);

            this.isDragging = false;
            this.hasDragged = false;
        }
    },
    beforeMount: function beforeMount() {
        if (this.$store.getters._theme) {
            this.$store.commit('SKIN_THEME', this.$store.getters._theme);
            if (this.$store.getters._theme == 2) {
                document.documentElement.classList.toggle('theme02');
            }
        }
        __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$on('stopTimer', function () {
            this.clearTimer();
        }.bind(this));
    },
    mounted: function mounted() {
        if (window.valid) {
            this.$store.commit('SET_ERROR', {});
            this.$store.commit('FIRST_LOAD', 1);
            this.getLSMatchList();
            this.refreshTimer();
        } else {
            this.$store.commit('SET_ERROR', {
                'error': '1',

                'message': 'Invalid Token'
            });
            this.$store.commit('FIRST_LOAD', 0);
        }

        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.handleResize);
        }
        $(document).ready(function () {
            $("#loading-root-ele").hide();
            var lastScrollTop = 0;
        });

        var playframe_original_style;
        window.addEventListener("message", function (ev) {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(ev.data) !== "object") return;
            if (!ev.data.type) return;
            if (ev.data.type !== "full_screen_click") return;
            var playframe_message = ev.data.message;
            var playframe = document.getElementById("mainLSTViframe");

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(playframe_message).length > 0) {
                var playframe_fullscreen_style = "";
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(playframe_message).forEach(function (val, idx) {
                    var style_name = val;
                    playframe_fullscreen_style += style_name + ': ' + playframe_message[val] + ';';
                });
                playframe_original_style = playframe.getAttribute("style");
                playframe.setAttribute("style", playframe_fullscreen_style);
                openFullscreen();
            } else {
                if (playframe_original_style != null) {
                    closeFullscreen();
                    playframe.setAttribute("style", playframe_original_style);
                } else {
                    playframe.removeAttribute("style");
                }
            }
        });

        this.pointerMQ = window.matchMedia('(pointer: coarse)');
        this.pointerMQ.addEventListener('change', this.handlePointerChange);
        this.handlePointerChange();
    },
    beforeUnmount: function beforeUnmount() {
        this.unbindScrollEvents();
        window.removeEventListener('resize', this.handleResize);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.handleResize);
        }
        this.pointerMQ.removeEventListener('change', this.handlePointerChange);
    },
    destroyed: function destroyed() {
        this.clearTimer();
        __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$off('stopTimer');
    }
});

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_http_interceptor__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__ = __webpack_require__(73);


__webpack_require__(84).polyfill();





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
	data: function data() {
		return {
			_: _
		};
	}
});


/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	components: { Core: __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__["a" /* default */] }
}));

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_apps_home_live_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_core_core__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__ = __webpack_require__(6);













history.pushState(null, null, location.href);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
  state: {
    _theme: window.theme,
    arr_lang: window.lang,
    titleSport: window.titleSport,
    lang_id: window.lang_id,
    liveMatchList: [],
    sortedliveMatchList: [],
    selectedMatch: {},
    selectedSport: '',
    firstLoad: 1,
    keyword: '',
    minWidth: 1100,
    isMobile: window.innerWidth < 1100,
    loginToken: window.loginToken,
    error: {}
  },
  getters: {
    _theme: function _theme(state) {
      return state._theme;
    },
    arr_lang: function arr_lang(state) {
      return state.arr_lang;
    },
    titleSport: function titleSport(state) {
      return state.titleSport;
    },
    lang_id: function lang_id(state) {
      return state.lang_id;
    },
    liveMatchList: function liveMatchList(state) {
      return state.liveMatchList;
    },
    sortedliveMatchList: function sortedliveMatchList(state) {
      return state.sortedliveMatchList;
    },
    selectedMatch: function selectedMatch(state) {
      return state.selectedMatch;
    },
    selectedSport: function selectedSport(state) {
      return state.selectedSport;
    },
    firstLoad: function firstLoad(state) {
      return state.firstLoad;
    },
    keyword: function keyword(state) {
      return state.keyword;
    },
    minWidth: function minWidth(state) {
      return state.minWidth;
    },
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    loginToken: function loginToken(state) {
      return state.loginToken;
    },
    error: function error(state) {
      return state.error;
    }
  },
  actions: {
    getLiveMatchList: function getLiveMatchList(context, payload) {
      var _this = this;

      var url = window._baseUrl + '/sport-live-match';
      var data = {
        lang: payload.lang,
        limitDisplay: window.limitDisplay,
        loginToken: this.getters.loginToken
      };

      __WEBPACK_IMPORTED_MODULE_7__js_core_core__["default"].$ajax({
        method: 'get',
        url: url,
        data: data
      }).done(function (res) {
        function getSelectedSport(data, selectedSport, titleSport) {
          var now = new Date();
          var sportSequence = titleSport.flatMap(function (item) {
            return item.sid;
          });

          var hasRunningRB = function hasRunningRB(sportid) {
            if (!data[sportid]) return false;
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data[sportid]).some(function (draw) {
              var dt = new Date(draw.dt.replace(' ', 'T') + '-04:00');
              return dt <= now;
            });
          };

          if (selectedSport && hasRunningRB(selectedSport)) {
            return selectedSport;
          }

          var autoSport = sportSequence.find(function (sportid) {
            return hasRunningRB(sportid);
          });
          if (autoSport) return autoSport;

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)[0] || '';
        }

        if (res.error) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('stopTimer');
          _this.commit('SET_ERROR', res);
        } else {
          _this.commit('SET_ERROR', {});
        }
        var data = res.data ? res.data : [];

        if (data.length > 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).length > 0) {
          var selectedSpt = payload.sport != '' && payload.sport != undefined ? payload.sport : getSelectedSport(data, _this.getters.selectedSport, _this.getters.titleSport);

          if (_this.getters.selectedSport != selectedSpt) {
            _this.commit('SELECTED_SPORT', selectedSpt);
          }

          var selectedMatch = _this.getters.selectedMatch;
          var currentSportMatches = data[selectedSpt] ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data[selectedSpt]) : [];

          if (!selectedMatch || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(selectedMatch).length === 0) {
            _this.dispatch('updateSelectedMatch', currentSportMatches.length > 0 ? currentSportMatches[0] : {});
          } else {
            var allMatches = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data).flatMap(function (sport) {
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(sport);
            });

            var matchExists = allMatches.some(function (m) {
              return m.eveid === selectedMatch.eveid;
            });

            if (!matchExists) {
              var fallbackSport = getSelectedSport(data, _this.getters.selectedSport, _this.getters.titleSport);
              if (fallbackSport !== _this.getters.selectedSport) {
                _this.commit('SELECTED_SPORT', fallbackSport);
              }
              var fallbackMatches = data[fallbackSport] ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(data[fallbackSport]) : [];
              _this.dispatch('updateSelectedMatch', fallbackMatches.length > 0 ? fallbackMatches[0] : {});
            } else {
              if (selectedMatch.sptid !== _this.getters.selectedSport) {
                _this.dispatch('updateSelectedMatch', currentSportMatches.length > 0 ? currentSportMatches[0] : {});
              }
            }
          }
        } else {
          _this.commit('SELECTED_SPORT', payload.sport != '' && payload.sport != undefined ? payload.sport : '1');
          _this.dispatch('updateSelectedMatch', {});
        }

        _this.commit('LIVE_MATCH_LIST', data);
        _this.dispatch('sortLiveMatch');
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    },
    sortLiveMatch: function sortLiveMatch(context, payload) {
      var ret = this.getters.liveMatchList;
      var selectedSport = this.getters.selectedSport;
      var newSortedEvents = [];
      var keyword = this.getters.keyword.trim().toLowerCase();

      if ((ret.length > 0 || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(ret).length > 0) && ret[selectedSport]) {
        if (keyword) {
          var res = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(ret).flatMap(function (events) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(events);
          }).sort(function (a, b) {
            return Number(a.evedt) - Number(b.evedt);
          });
          _.forEach(res, function (val, key) {
            if (!keyword || keyword && (val.lgecap && val.lgecap.trim().toLowerCase().indexOf(keyword) !== -1 || val.tacap && val.tacap.trim().toLowerCase().indexOf(keyword) !== -1 || val.tbcap && val.tbcap.trim().toLowerCase().indexOf(keyword) !== -1)) {
              newSortedEvents.push(val);
            }
          });
        } else {
          newSortedEvents = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(ret[selectedSport]);
        }
      }
      this.commit('SORTED_LIVE_MATCH_LIST', newSortedEvents);
    },
    updateSelectedMatch: function updateSelectedMatch(context, payload) {
      var _this2 = this;

      if (payload && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).length > 0) {
        this.dispatch('getLiveStreamURL', {
          ch: payload.ch,
          eveid: payload.eveid,
          sptid: payload.sptid
        }).then(function (tvlink) {
          var updatedPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, {
            tvlink: tvlink
          });
          _this2.commit('SELECTED_MATCH', updatedPayload);
        }).catch(function (err) {
          console.error('Failed to get live stream URL:', err);
          var updatedPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, { tvlink: null });
          _this2.commit('SELECTED_MATCH', updatedPayload);
        });
      } else {
        this.commit('SELECTED_MATCH', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload));
      }
    },
    getLiveStreamURL: function getLiveStreamURL(context, payload) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = window._baseUrl + '/livetv';
        var data = {
          chlid: payload.ch,
          eventid: payload.eveid,
          sptid: payload.sptid,
          livepage: 1,
          passkey: window.passkey_det.passkey,
          passkeyid: window.passkey_det.id
        };
        __WEBPACK_IMPORTED_MODULE_7__js_core_core__["default"].$ajax({
          method: 'post',
          url: url,
          data: data
        }).done(function (res) {
          resolve(res);
        }).catch(function (err) {
          console.error(err);
          reject(err);
        });
      });
    }
  },
  mutations: {
    SKIN_THEME: function SKIN_THEME(state, payload) {
      state._theme = payload;
    },
    LIVE_MATCH_LIST: function LIVE_MATCH_LIST(state, payload) {
      state.liveMatchList = payload;
    },
    SORTED_LIVE_MATCH_LIST: function SORTED_LIVE_MATCH_LIST(state, payload) {
      state.sortedliveMatchList = payload;
    },
    SELECTED_MATCH: function SELECTED_MATCH(state, payload) {
      state.selectedMatch = payload;
      if (this.getters.firstLoad == 1) {
        this.commit('FIRST_LOAD', 0);
      }
    },
    SELECTED_SPORT: function SELECTED_SPORT(state, payload) {
      state.selectedSport = payload;
    },
    FIRST_LOAD: function FIRST_LOAD(state, payload) {
      state.firstLoad = payload;
      var wait_lang = this.getters.arr_lang.home['HOME.LIVESTREAM_WAIT'];
      var no_match_lang = this.getters.arr_lang.home['HOME.NO_LIVE_NOW'];
      $('.leftMLS-col-text').each(function () {
        var text = payload === 1 ? wait_lang.trim() : no_match_lang.trim();
        var html = '';

        for (var i = 0; i < text.length; i++) {
          var delay = i * 0.08;
          var char = text[i] === ' ' ? '&nbsp;' : text[i];
          html += '<span style="animation-delay:' + delay + 's">' + char + '</span>';
        }

        $(this).html(html);
      });
    },
    SET_KEYWORD: function SET_KEYWORD(state, payload) {
      state.keyword = payload;
    },
    IS_MOBILE: function IS_MOBILE(state, payload) {
      state.isMobile = payload;
    },
    SET_ERROR: function SET_ERROR(state, payload) {
      state.error = payload;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
  el: '#landing',
  template: '<Home></Home>',
  store: store,
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_4__vue_apps_home_live_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_live_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12938f54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_live_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_live_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12938f54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_live_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-layout q-layout--containerized"},[_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"containerLS"},[_c('div',{staticClass:"banner-row"},[_c('span',{staticClass:"banner-text"},[_vm._v("\n                    "+_vm._s(_vm.arr_lang.home['HOME.POPULAR_LIVE_STREAM'])+"\n                    "),_c('small',[_vm._v(_vm._s(_vm.arr_lang.home['HOME.LIVE_STREAM_DESCRIPTION']))])])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"website-wrap"},[_c('div',{staticClass:"MLSrow1"},[_c('div',{staticClass:"MLScolB1",style:((Object.keys(_vm.selectedMatch).length > 0)? 'visibility: visible;':'visibility: hidden;')},[(Object.keys(_vm.selectedMatch).length > 0)?[_c('span',{staticClass:"MLSicon",class:'g'+_vm.selectedMatch.sptid+'-icon'}),_vm._v(" "),_c('div',{staticClass:"lsteam"},[_c('span',{staticClass:"MLSteams title-teama",style:(['1','2'].includes(_vm.selectedMatch.sptid)? 'max-width: 132px;':'max-width: 170px;'),attrs:{"title":_vm.selectedMatch.tacap}},[_vm._v(_vm._s(_vm.selectedMatch.tacap))]),_vm._v(" "),(['1','2'].includes(_vm.selectedMatch.sptid) && _vm.selectedMatch.talogo)?_c('div',{staticClass:"team_logo ta_logo"},[_c('img',{attrs:{"src":_vm.selectedMatch.talogo}})]):_vm._e()]),_vm._v(" "),_c('span',[_vm._v(" VS ")]),_vm._v(" "),_c('div',{staticClass:"lsteam"},[(['1','2'].includes(_vm.selectedMatch.sptid) && _vm.selectedMatch.tblogo)?_c('div',{staticClass:"team_logo tb_logo"},[_c('img',{attrs:{"src":_vm.selectedMatch.tblogo}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"MLSteams title-teamb",style:(['1','2'].includes(_vm.selectedMatch.sptid)? 'max-width: 132px;':'max-width: 170px;'),attrs:{"title":_vm.selectedMatch.tbcap}},[_vm._v(_vm._s(_vm.selectedMatch.tbcap))])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"right-fixed"},[_c('div',{staticClass:"MLScolA1",attrs:{"aria-label":"button group"}},[_c('button',{staticClass:"scroll-MLSbtn",attrs:{"id":"scrollLeft","disabled":""},on:{"click":function($event){return _vm.clickToScroll('left')}}},[_vm._v("◀")]),_vm._v(" "),_c('div',{ref:"tabWrapList",staticClass:"MLSscroll-wrapper",attrs:{"id":"scrollContainer","role":"group","aria-label":"items"}},[_vm._l((_vm.titleSport),function(sport,key){return [_c('button',{staticClass:"btn-ls-game",class:_vm.selectedSport == sport.sid[0]? 'active-MLSbtn':'inactive-MLSbtn',attrs:{"id":'btnLSGame'+sport.sid[0]},on:{"click":function($event){return _vm.onSportClick(sport.sid[0], $event)}}},[_vm._v(_vm._s(_vm.arr_lang.configLang[sport.titleLang]))])]})],2),_vm._v(" "),_c('button',{staticClass:"scroll-MLSbtn",attrs:{"id":"scrollRight"},on:{"click":function($event){return _vm.clickToScroll('right')}}},[_vm._v("▶")])]),_vm._v(" "),_c('div',{staticClass:"searchMLS-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKeyword),expression:"searchKeyword"}],staticClass:"searchMLS-input",attrs:{"type":"text","id":"searchInput","placeholder":_vm.arr_lang.home['HOME.ENTER_LEAGUE_TEAM']},domProps:{"value":(_vm.searchKeyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchKeyword=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"MLSrow2"},[_c('div',{staticClass:"leftMLS-col",attrs:{"id":"LSTV"}},[(Object.keys(_vm.selectedMatch).length > 0 && _vm.selectedMatch.tvlink)?_c('iframe',{staticStyle:{"border":"none","position":"absolute","inset":"0px","width":"100%","height":"auto","aspect-ratio":"16 / 9"},attrs:{"id":"mainLSTViframe","src":_vm.selectedMatch.tvlink,"allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","allow":"fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","referrerpolicy":"no-referrer","sandbox":"allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock allow-modals"}}):_c('div',{staticClass:"leftMLS-col-text",class:{ 'wave-text': _vm.firstLoad == 1 }},[(_vm.firstLoad == 1)?[_vm._v(_vm._s(_vm.arr_lang.home['HOME.LIVESTREAM_WAIT']))]:[_vm._v(_vm._s(_vm.arr_lang.home['HOME.NO_LIVE_NOW']))]],2)]),_vm._v(" "),_c('div',{staticClass:"rightMLS-col scrollable"},[(_vm.sortedliveMatchList && _vm.sortedliveMatchList.length > 0)?[_vm._l((_vm.sortedliveMatchList),function(val,key){return [_c('div',{staticClass:"lsmatch-info lsmatch",class:'lsmatchbygame_'+val.sptid,attrs:{"id":'lsm_'+val.eveid},on:{"click":function($event){return _vm.getLiveStreamURL(val)}}},[_c('div',{staticClass:"lstlg-row"},[_c('div',{staticClass:"lstlg-icon",class:['g'+val.sptid+'-icon', { 'rb':(val.rb == 1 && val.rbstatus == 1) }, { 'selected':(val.eveid == _vm.selectedMatch.eveid) }]}),_vm._v(" "),_c('div',{staticClass:"lstlg",attrs:{"title":val.lgecap}},[_vm._v(_vm._s(val.lgecap))])]),_vm._v(" "),_c('div',{staticClass:"match-content"},[_c('div',{staticClass:"lsteam"},[(['1','2'].includes(val.sptid) && val.talogo)?_c('div',{staticClass:"team_logo ta_logo"},[_c('img',{attrs:{"src":val.talogo}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lsta",attrs:{"title":val.tacap}},[_vm._v(_vm._s(val.tacap))])]),_vm._v(" "),_c('div',{staticClass:"lsti"},[_c('div',[_vm._v(_vm._s(val.score))]),_vm._v(" "),_c('div',{staticClass:"lstdt",class:{ 'streaming':(val.rb == 1 && val.rbstatus == 1) }},[_vm._v(_vm._s((val.rb == 1 && val.rbstatus == 1)? _vm.arr_lang.home['HOME.STREAMING']:_vm.getDateTimeFormat(val.dt)))])]),_vm._v(" "),_c('div',{staticClass:"lsteam"},[_c('div',{staticClass:"lstb",attrs:{"title":val.tbcap}},[_vm._v(_vm._s(val.tbcap))]),_vm._v(" "),(['1','2'].includes(val.sptid) && val.tblogo)?_c('div',{staticClass:"team_logo tb_logo"},[_c('img',{attrs:{"src":val.tblogo}})]):_vm._e()])])])]})]:[_c('div',{staticClass:"lsmatch-info no-match lsmatchbygame_3"},[_vm._v(_vm._s(_vm.error && _vm.error.code? _vm.arr_lang.home['HOME.'+_vm.error.code]:_vm.arr_lang.home['HOME.NO_LIVE_MATCH']))])]],2)])]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-wrap"},[_c('div',{staticClass:"MLSrow1"},[_c('div',{staticClass:"right-fixed",class:{ focus: _vm.isSearchFocus }},[_c('div',{staticClass:"MLScolA1",attrs:{"aria-label":"button group"}},[_c('div',{ref:"tabWrapList",staticClass:"MLSscroll-wrapper mob-dev",attrs:{"id":"scrollContainer","role":"group","aria-label":"items"}},[_vm._l((_vm.titleSport),function(sport,key){return [_c('button',{staticClass:"btn-ls-game",class:_vm.selectedSport == sport.sid[0]? 'active-MLSbtn':'inactive-MLSbtn',attrs:{"id":'btnLSGame'+sport.sid[0]},on:{"click":function($event){return _vm.onSportClick(sport.sid[0], $event)}}},[_c('div',{staticClass:"btn-ls-game-icon",class:['g'+sport.sid[0]+'-icon', { 'selected': _vm.selectedSport == sport.sid[0] }]}),_vm._v(" "),(!_vm.hideSportTitle)?_c('div',[_vm._v(_vm._s(_vm.arr_lang.configLang[sport.titleLang]))]):_vm._e()])]})],2)]),_vm._v(" "),_c('div',{staticClass:"searchMLS-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchKeyword),expression:"searchKeyword"}],staticClass:"searchMLS-input",attrs:{"type":"text","id":"searchInput","placeholder":_vm.arr_lang.home['HOME.ENTER_LEAGUE_TEAM']},domProps:{"value":(_vm.searchKeyword)},on:{"click":_vm.onSearchFocus,"input":function($event){if($event.target.composing){ return; }_vm.searchKeyword=$event.target.value}}}),_vm._v(" "),(_vm.isSearchFocus)?_c('button',{staticClass:"search-close",on:{"click":_vm.closeSearch}},[_vm._v("✕")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"MLSrow2"},[_c('div',{staticClass:"rightMLS-col scrollable"},[(_vm.sortedliveMatchList && _vm.sortedliveMatchList.length > 0)?[_vm._l((_vm.sortedliveMatchList),function(val,key){return [_c('div',{staticClass:"lsmatch-info lsmatch",class:'lsmatchbygame_'+val.sptid,attrs:{"id":'lsm_'+val.eveid},on:{"click":function($event){return _vm.getLiveStreamURL(val)}}},[_c('div',{staticClass:"lstlg-row"},[_c('div',{staticClass:"lstlg-icon",class:['g'+val.sptid+'-icon', { 'rb':(val.rb == 1 && val.rbstatus == 1) }, { 'selected':(val.eveid == _vm.selectedMatch.eveid) }]}),_vm._v(" "),_c('div',{staticClass:"lstlg",attrs:{"title":val.lgecap}},[_vm._v(_vm._s(val.lgecap))])]),_vm._v(" "),_c('div',{staticClass:"match-content"},[_c('div',{staticClass:"lsteam"},[(['1','2'].includes(val.sptid) && val.talogo)?_c('div',{staticClass:"team_logo ta_logo"},[_c('img',{attrs:{"src":val.talogo}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lsta",attrs:{"title":val.tacap}},[_vm._v(_vm._s(val.tacap))])]),_vm._v(" "),_c('div',{staticClass:"lsti"},[_c('div',[_vm._v(_vm._s(val.score))]),_vm._v(" "),_c('div',{staticClass:"lstdt",class:{ 'streaming':(val.rb == 1 && val.rbstatus == 1) }},[_vm._v(_vm._s((val.rb == 1 && val.rbstatus == 1)? _vm.arr_lang.home['HOME.STREAMING']:_vm.getDateTimeFormat(val.dt)))])]),_vm._v(" "),_c('div',{staticClass:"lsteam"},[_c('div',{staticClass:"lstb",attrs:{"title":val.tbcap}},[_vm._v(_vm._s(val.tbcap))]),_vm._v(" "),(['1','2'].includes(val.sptid) && val.tblogo)?_c('div',{staticClass:"team_logo tb_logo"},[_c('img',{attrs:{"src":val.tblogo}})]):_vm._e()])])]),_vm._v(" "),(Object.keys(_vm.selectedMatch).length > 0 && val.eveid == _vm.selectedMatch.eveid)?_c('div',{staticClass:"leftMLS-col",attrs:{"id":'LSTV'+val.eveid}},[(_vm.selectedMatch.tvlink)?_c('iframe',{staticStyle:{"border":"none","position":"absolute","inset":"0px","width":"100%","height":"auto","aspect-ratio":"16 / 9"},attrs:{"id":"mainLSTViframe","src":_vm.selectedMatch.tvlink,"allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":"","allow":"fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","referrerpolicy":"no-referrer","sandbox":"allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock allow-modals"}}):_c('div',{staticClass:"leftMLS-col-text",class:{ 'wave-text': _vm.firstLoad == 1 }},[(_vm.firstLoad == 1)?[_vm._v(_vm._s(_vm.arr_lang.home['HOME.LIVESTREAM_WAIT']))]:[_vm._v(_vm._s(_vm.arr_lang.home['HOME.NO_LIVE_NOW']))]],2)]):_vm._e()]})]:[_c('div',{staticClass:"lsmatch-info no-match lsmatchbygame_3"},[_vm._v(_vm._s(_vm.error && _vm.error.code? _vm.arr_lang.home['HOME.'+_vm.error.code]:_vm.arr_lang.home['HOME.NO_LIVE_MATCH']))])]],2)])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__ = __webpack_require__(6);




window.loading = false;

$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    var index = '';
    var token_val = '';
    var enableLoading = false;
    if (settings.data) {
      var data = settings.data.split('&');
      var data = data.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.data = settings.data.replace("&enableLoading=false", "");
      settings.data = settings.data.replace("&enableLoading=true", "");
      var url = settings.data;
    } else if (settings.type == 'GET') {
      var data = settings.url.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.url = settings.url.replace("&enableLoading=false", "");
      settings.url = settings.url.replace("&enableLoading=true", "");
      var url = settings.url;
    }
    settings.url = settings.url.replace("?enableLoading=false", "");
    settings.url = settings.url.replace("?enableLoading=true", "");
    if (url) {
      var valid = url.indexOf("&");
      if (valid >= 0) {
        var suburl = url.split('&');
        var delimiter = '&';
      } else {
        var suburl = url.split('?');
        var delimiter = '?';
      }

      suburl.forEach(function (value, i) {
        if (value.substring(0, 6) == 'token=') {
          index = i;
          token_val = value.split('=');
          if (settings.data) {
            settings.data = url.replace(delimiter + suburl[index], "");
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "");
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      });
    }
    if (enableLoading) {
      __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('enableLoading', enableLoading);
    }
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () {
            return $('meta[name="csrf_name"]').attr('content');
          }(),
          'csrf_value': function () {
            return $('meta[name="csrf_value"]').attr('content');
          }()
        };
      }
      return true;
    }
  }
});

$(document).ajaxSuccess(function (event, xhr, options) {

  if (!_.isUndefined(xhr.responseJSON)) {
    if (xhr.responseJSON.redirect) {
      window.location.href = xhr.responseJSON.redirect;
    }
  }
});

$(document).ajaxComplete(function (event, xhr, options) {
  if (window.navigator.userAgent.indexOf('Safari') >= 0 && window.navigator.userAgent.indexOf('Chrome') == -1) {
    $('.gridContainer').height('90vh');
    $('.gridContainer').css('overflow-y', 'auto');
  }
  if (xhr.getResponseHeader('X-Auth') == '0') {
    window.location = 'login';
  }

  if (xhr.status === 0) {
    location.reload();
  }

  if (xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')) {
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = $.ajax;

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(11)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[570]);


// WEBPACK FOOTER //
// js/home/live.0e390d5dea1127a32b60.js